import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { Picking } from "interfaces/picking";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_PICKING_QUARENTINES_" }
);

export interface PaginatePickingQuarentinesState extends IState {
  data: Picking[] | Record<string, any>[];
}

const INITIAL_STATE: PaginatePickingQuarentinesState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginatePickingQuarentinesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginatePickingQuarentinesState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginatePickingQuarentinesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginatePickingQuarentines = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginatePickingQuarentinesTypes = Types;
export const PaginatePickingQuarentinesActions = Creators;
